<template>
	<div class="news">
		<div class="bg"></div>
		<h1 class="title text_theme">NEWS</h1>
		<h1 class="title">TENDENCY</h1>
		<h3 class="sub_title text_theme"><span>新闻动态</span></h3>
		<div class="clear_both">
			<div class="swiper_control">
				<i class="prev" @click="handlePrevClick"></i>
				<i class="next" @click="handleNextClick"></i>
			</div>
			<div class="swiper_box">
				<div class="swiper-container" style="height: 100%;">
					<div class="swiper-wrapper">
						<div v-for="(v, i) in news" :key="i" class="swiper-slide clear_both" :data-id="v.index">
							<div v-for="(vv, ii) in v" :key="vv.index" class="new" :style="{'margin-right': ii % 2 ? '0px' : '80px'}">
								<div class="new_img">
									<div class="new_img_wrap">
										<img :src="vv.poster" alt="">
									</div>
								</div>
								<div class="new_name text_one">{{ vv.title }}<span>{{ vv.date }}</span></div>
								<p class="new_content text_five">{{ vv.summary }}</p>
								<div class="new_btn"><button @click="handleItemClick(vv.index)">MORE</button></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import News from '../../../../db/news.js';
	
	export default {
		mounted() {
			this.formatNews();
			this.initSwiper();
		},
		data() {
			return{
				news: []
			}
		},
		methods: {
			/***************** @Events **********************/
			// 点击上一页
			handlePrevClick() {
				this.swiper_instance.slidePrev(500);
			},
			// 点击下一页
			handleNextClick() {
				this.swiper_instance.slideNext(500);
			},
			// 进入详情
			handleItemClick(index) {
				this.$router.push({path: `/index/news?index=${ index }`});
			},
			
			/***************** @Function **********************/
			// 初始化swiper
			initSwiper() {
				this.$nextTick(() => {
					this.swiper_instance = new this.Swiper('.news .swiper-container', {
						loop: true,
						allowTouchMove: false,
						effect: 'fade',
						fadeEffect: {
							crossFade: true
						}
					});
				});
			},
			// 格式化新闻数据
			formatNews() {
				let news = [];
				for (let k in News) {
					news[Math.floor(k/2)] || (news[Math.floor(k/2)] = []);
					news[Math.floor(k/2)].push(News[k]);
				}
				this.news = news;
			}
		}
	}
</script>

<style scoped>
	.news{ position: relative;width: 1200px;margin: 0 auto;padding: 86px 0 100px 0; }
	.news .bg{ position: absolute;width: 1394px;height: 550px;bottom: 100px;left: 160px;background: #f3f3f3; }
	.news .title{ font-size: 45px;line-height: 54px; }
	.news .sub_title{ position: relative;margin-top: 10px;font-size: 30px;line-height: 30px; }
	.news .sub_title::before{ content: "";display: block;position: absolute;width: 166px;height: 11px;bottom: 0px;left: 0;background: #ffb805; }
	.news .sub_title span{ display: block;position: relative;z-index: 9; }
	.news .swiper_control{ float: left;width: 160px;padding: 92px 0 0 0; }
	.news .prev{ display: inline-block;width: 40px;height: 40px;margin-right: 16px;background-image: url(../../../../assets/prev_circle_icon.png);background-size: cover;vertical-align: top; }
	.news .next{ display: inline-block;width: 40px;height: 40px;background-image: url(../../../../assets/next_circle_icon.png);background-size: cover;vertical-align: top; }
	.news .prev:hover{ background-image: url(../../../../assets/prev_on_circle_icon.png);background-size: cover;cursor: pointer; }
	.news .next:hover{ background-image: url(../../../../assets/next_on_circle_icon.png);background-size: cover;cursor: pointer; }
	.news .swiper_box{ position: relative;top: -10px;float: right;width: 974px;height: 642px; }
	.news .new{ float: left;width: 447px; }
	.news .new_img{ position: relative;height: 257px;padding: 10px 10px 0 0;}
	.news .new_img::before{ content: "";display: block;position: absolute;width: 184px;height: 10px;top: 0px;right: 0;background: #ffb805; }
	.news .new_img::after{ content: "";display: block;position: absolute;width: 10px;height: 184px;top: 0px;right: 0;background: #ffb805; }
	.news .new_img_wrap{ width: 100%;height: 100%;overflow: hidden; }
	.news .new_img_wrap img{ display: block;width: 100%;height: 100%; }
	.news .new_name{ position: relative;margin-top: 48px;padding: 0 90px 0 0;font-size: 16px;font-weight: bold;color: #060606;line-height: 46px; }
	.news .new_name span{ display: block;position: absolute;width: 90px;top: 0;right: 0;font-weight: normal;text-align: right; }
	.news .new_name::after{ content: "";display: block;position: absolute;width: 100%;height: 1px;bottom: 0;left: 0;background: #999; }
	.news .new_content{ height: 100px;margin-top: 34px;font-size: 16px;color: #060606;line-height: 20px; }
	.news .new_btn{ margin-top: 15px; }
	.news .new_btn button{ padding: 0 40px;line-height: 38px; }
</style>
